<template>
  <div class="delivery-period-wrapper" :class="{ error: error }">
    <div
      class="delivery-period"
      :class="{ open: blockVisible, error: error }"
      v-click-outside="closeBlock"
      @click="onclick"
    >
      <div class="delivery-period__placeholder" @click="setBlockVisible">
        <span v-if="!value" class="grey">Время</span>
        <span v-if="value">{{ value }}</span>
      </div>
      <div
        v-for="item in data"
        :key="item.id"
        @click="() => setDeliveryPeriod(item.id, item.value)"
        class="delivery-period__row"
      >
        <span>{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      value: '',
      blockVisible: false,
    };
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    error: {
      type: Boolean,
    },
  },
  methods: {
    setBlockVisible: function() {
      this.blockVisible = !this.blockVisible;
    },
    setDeliveryPeriod: function(id, value) {
      this.value = value;
      this.$emit('change', id);
      this.blockVisible = false;
    },
    closeBlock: function() {
      this.blockVisible = false;
    },
    onclick: function() {
      this.$emit('onclick', this.value);
    },
  },
};
</script>

<style lang="sass" scoped>
.delivery-period
  width: 180px
  min-height: 48px
  max-height: 48px
  border: 1px solid #A0AFC5
  border-radius: 50px
  padding: 0 24px
  transition: max-height .2s, border-radius .2s .1s, background-color .2s
  overflow: hidden
  &-wrapper
    &.error
      position: relative
      &:after
        content: 'Выберите время'
        position: absolute
        bottom: -13px
        left: 24px
        color: #F24949
        font-size: 10px
        line-height: 1
  &.error
    border: 1px solid #F24949
  &.open
    max-height: 500px
    padding-bottom: 12px
    background: #FFFFFF
    box-shadow: 0 3px 8px rgba(183, 195, 211, .3)
    border-radius: 24px
    transition: max-height .2s, border-radius 0s 0s, background-color .2s

  &__placeholder
    position: relative
    cursor: pointer
    span
      font-size: 16px
      line-height: 46px
      color: #000000
      &.grey
        opacity: .5
      &:after
        content: ''
        position: absolute
        width: 12px
        height: 12px
        top: 50%
        right: 0
        transform: translateY(-50%)
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgBjZDvCQIxDMVf+8GdRARxg8MBxA2cwKYucjhBR6ig4B6OcAMklx7ccfR6fx4EQpNfXxJAVYfPCRskIkOvSYmBjRp0rfZ+Doox4t/sSBgPAZ/trTq+NfEa9Ao/twoxnokxfVGdSV1d7jyBLgdK77Zv0F+o5FyCuh3zscbOsAwFXA4VwTHcXZLhc2hRCa7D9z5XbwF98GNPlwrxOAAAAABJRU5ErkJggg==)
        background-position: 50%
        background-repeat: no-repeat
  &__row
    cursor: pointer
    text-align: center
    span
      font-size: 16px
      line-height: 33px
      &:hover
        background-color: rgba(220, 226, 233, .5)
        border-radius: 50px
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/deliveryperiod.vue